<template>
  <div>
    <DepartmentRuleDetail type="new" :submitting="submitting" @submit="submit" />
  </div>
</template>

<script>
import { helper } from '@core/mixins/helper.js';
import DepartmentRuleDetail from '@/views/pages/departments/rule/DepartmentRuleDetail.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    DepartmentRuleDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false
    };
  },

  methods: {
    submit(data) {
      const { id } = this.$route.params;
      this.submitting = true;
      useService.departmentService
        .createDepartmentRule(id, data)
        .then(response => {
          this.$router.push({ name: 'departments_rules', params: { id } });
          this.showSuccessMessage(
            `${
              response.message ||
              (this.type === 'new'
                ? this.$t('Create Department Success Message')
                : this.$t('Edit Department Success Message'))
            }`
          );
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
